import { Component, Input, OnInit } from '@angular/core';
import { RouterModule, ActivatedRoute } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { ChangeGameComponent } from '../change-game.component';
import { FuseCardComponent } from '@fuse/components/card';
import { MatIconModule } from '@angular/material/icon';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FuseMediaWatcherService } from '@fuse/services/media-watcher';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-change-game-type01',
  standalone: true,
  imports: [RouterModule, FuseCardComponent, MatIconModule, SlickCarouselModule],
  templateUrl: './change-game-type01.component.html',
  styleUrl: './change-game-type01.component.scss'
})
export class ChangeGameType01Component extends ChangeGameComponent implements OnInit {
  @Input('heading') heading: string = 'Beyond the Ordinary';
  @Input('title') title: string = 'XL Travel';
  @Input('features') features: [] = [];
  @Input('options') options: any = { showSlider: false };

  public view: any = {};

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(protected _tfmService: TFMService, private route: ActivatedRoute, private _fuseMediaWatcherService: FuseMediaWatcherService) {
    super(_tfmService);

    this._tfmService.getSite().then(res => {
      this.view.site = res;
      this._tfmService.log('Change Game Site: ', this.view.site);

      this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
    });

    this._fuseMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.view.isScreenSmall = !matchingAliases.includes('md');
      });

    // Access profileID after parent logic completes
    this.loadGameDetails().then(() => {

      // Now that the id will be available for child component...
      this.view.profileId = this.view.site?.profileID;
      console.log(this.view.profileId);
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.view.solutionType = params['type'];
      // You can now use solutionType to determine which component or logic to execute
      if (this.view.solutionType === 'holidays') {
        this.view.headerTitle = 'Xl Travel';
      }
      else if (this.view.solutionType === 'howzit') {
        this.view.headerTitle = 'Howzit';
      }
      else if (this.view.solutionType === 'rewards') {
        this.view.headerTitle = 'Rewards';
      }
      else {
        this.view.headerTitle = 'We';
      }
      console.log('Selected Solution Type:', this.view.solutionType);

      this.view.heading = this.heading;
      this.view.title = this.title;
      this.view.features = this.features;
      this.view.options = this.options;
    });
    
    this._tfmService.getContentBySection('corporate-travel').then((res) => {
      this.view.page = res;
    });
  }

  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  // addSlide() {
  //   this.slides.push({img: "http://placehold.it/350x150/777777"})
  // }

  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }

  slickInit(e) {
    this._tfmService.log('slick initialized');
  }

  breakpoint(e) {
    this._tfmService.log('breakpoint');
  }

  afterChange(e) {
  }

  beforeChange(e) {
  }
}
